import React, { ChangeEvent, useEffect, useState } from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../app/store";
import {
  changeJobStatus,
  getAllJobs,
  sendJobEmail,
  updateJobStatus,
} from "../../features/jobSlice";
import moment from "moment";
import { toast } from "react-toastify";
import { PuffLoader } from "react-spinners";

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

const Jobs = () => {
  const job_url = process.env.REACT_APP_JOB_URL;
  const [executed, setExecuted] = useState(false);
  const [jobId, setJobId] = useState<number>(0);
  const [shareTitle, setTitle] = useState<string>("");
  const [userEmail, setEmail] = useState<string>("");
  const [jobTitleRequest, setJobTitleRequest] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // Search state

  const { user } = useAppSelector((state) => state.auth);

  //modals
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (id: number, title: string) => {
    setShow(true);
    setJobId(id);
    setTitle(title);
  };

  //send mail to user
  const sendMail = () => {
    let links: string = `${job_url}?id=${jobId}`;
    let userName: string = user.first_name;
    let data = {
      link: links,
      name: userName,
      email: userEmail,
    };

    dispatch(sendJobEmail(data))
      .unwrap()
      .then((response) => {
        setShow(false);
        toast.success("Job sent successfully");
      })
      .catch((error) => {
        toast.error(error);
      });
    console.log(`${job_url}/${jobId}`, userEmail);
  };

  //dispatch
  const dispatch = useAppDispatch();
  const { jobs, isLoading } = useAppSelector((state) => state.job);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      dispatch(getAllJobs({ search: jobTitleRequest }));
    }, 1000); // 500ms debounce delay

    return () => clearTimeout(delayDebounce); // cleanup on new keystroke
  }, [jobTitleRequest, dispatch, executed]);

  const handleStatusChange = async (
    e: ChangeEvent<HTMLSelectElement>,
    id: number
  ) => {
    const newStatus = e.target.value;

    const data = {
      jobStatus: newStatus,
      jobIds: id,
    };
    dispatch(changeJobStatus(data))
      .unwrap()
      .then((response: any) => {
        toast.success("Job Status Updated");
        setExecuted(!executed);
      })
      .catch((error) => {
        toast.error(error);
      }); // Dispatching the action to update job status
  };

  const jobStatusOptions = [
    { value: "Paused", label: "Paused" },
    { value: "Published", label: "Open" },
    { value: "Closed", label: "Closed" },
    { value: "Saved", label: "Saved" },
  ];

  if (isLoading)
    return (
      <div className="flex d-flex justify-content-center align-item center py-5 mt-5">
        <PuffLoader
          color="#073367"
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );

  // Filter job types by search term
  const filteredJobTypes = jobs?.data.filter((item: any) =>
    item.jobTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <>
      <AuthLayout>
        <div className="d-flex flex-row justify-content-between mt-3">
          <div>
            <a href="/createJob" className="btn btn-secondary text-white">
              Create New Job
            </a>
          </div>
          <div>
            <div className="form-group has-search">
              <span className="bi bi-search form-control-feedback"></span>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="mt-3">
          <table className="table table-hover custom-table">
            <thead className="bg-primary text-white rounded">
              <tr>
                <th>Job</th>
                <th>Candidates</th>
                <th>Job Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredJobTypes && filteredJobTypes.length > 0 ? (
                filteredJobTypes.map((item) => (
                  <tr key={item.id}>
                    <td className="p-3">
                      <div className="fw-bold fs-8 text-dark">
                        {item.jobTitle}
                      </div>
                      <small className="text-muted">{item.jobLocation}</small>{" "}
                      <small className="text-muted">{item.jobType}</small>
                      <br />
                      <small className="text-muted">
                        Created: {moment(item.openDate).format("MMM DD, YYYY")}{" "}
                        - Ends: {moment(item.closeDate).format("MMM DD, YYYY")}
                      </small>
                    </td>

                    <td className="p-3">
                      <td>
                        <div className="candidate-summary row text-center">
                          <div className="col">
                            <strong> {item.total_applicants_count}</strong>
                            <br />
                            <span className="small-label">Candidate</span>
                          </div>
                          <div className="col">
                            <strong> {item.pending_applicants_count}</strong>
                            <br />
                            <span className="small-label">Awaiting</span>
                          </div>
                          <div className="col">
                            <strong>{item.reviewed_applicants_count}</strong>
                            <br />
                            <span className="small-label">Shortlisted</span>
                          </div>
                          <div className="col">
                            <strong>{item.interview_applicants_count}</strong>
                            <br />
                            <span className="small-label">Interview</span>
                          </div>
                          <div className="col">
                            <strong>{item.hired_applicants_count}</strong>
                            <br />
                            <span className="small-label">Hired</span>
                          </div>
                          <div className="col">
                            <strong>{item.total_clicks}</strong>
                            <br />
                            <span className="small-label">Clicks</span>
                          </div>
                        </div>
                      </td>
                    </td>

                    <td className="pt-4 ">
                      <select
                        className="form-select-sm border-dark"
                        name="jobStatus"
                        value={item.jobStatus}
                        onChange={(e) => handleStatusChange(e, item.id)}
                      >
                        {jobStatusOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td className="pt-4">
                      <a
                        className="dropdown-toggle px-2 py-1 border rounded text-center text-decoration-none border-black text-black"
                        href="#"
                        id={`dropdownMenuLink-${item.id}`}
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Action
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby={`dropdownMenuLink-${item.id}`}
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            href={`/manageJob/details/${item.id}`}
                          >
                            View Job Profile
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href={`/manageJob/manage-applicants/${item.id}`}
                          >
                            Manage Applicant
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href={`/duplicateJob/${item.id}`}
                          >
                            Duplicate Job
                          </a>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            type="button"
                            onClick={() => handleShow(item.id, item.jobTitle)}
                          >
                            Share
                          </button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center py-4">
                    No jobs available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </AuthLayout>
      <Modal show={show} onHide={handleClose} className="rounded-0">
        <Modal.Header
          className="rounded-0"
          closeButton
          style={{ backgroundColor: "#E5E9FF" }}
        >
          <Modal.Title className="font-15">Share this link via</Modal.Title>
        </Modal.Header>
        <Modal.Body className="rounded-0">
          <Row>
            <Col
              sm={12}
              md={3}
              className="d-flex flex-column align-items-center"
            >
              <WhatsappShareButton
                url={`${job_url}?id=${jobId}`}
                title={shareTitle}
              >
                <div className="border p-2">
                  <img
                    src="/images/svg/logos_whatsapp-icon.svg"
                    alt="whatsapp"
                  />
                </div>{" "}
                <p>Whatsapp</p>
              </WhatsappShareButton>
            </Col>

            <Col
              sm={12}
              md={3}
              className="d-flex flex-column align-items-center"
            >
              <FacebookShareButton url={`${job_url}?id=${jobId}`}>
                <div className="border p-2">
                  <img src="/images/svg/logos_facebook.svg" alt="facebook" />
                </div>
                <p>Facebook</p>
              </FacebookShareButton>
            </Col>

            <Col
              sm={12}
              md={3}
              className="d-flex flex-column align-items-center"
            >
              <TwitterShareButton
                url={`${job_url}?id=${jobId}`}
                title={shareTitle}
              >
                <div className="border p-2">
                  <img src="/images/svg/line-md_twitter-x.svg" alt="twitter" />
                </div>
                <p>Twitter</p>
              </TwitterShareButton>
            </Col>

            <Col
              sm={12}
              md={3}
              className="d-flex flex-column align-items-center"
            >
              <LinkedinShareButton
                url={`${job_url}?id=${jobId}`}
                title={shareTitle}
              >
                <div className="border p-2">
                  <img
                    src="/images/svg/skill-icons_linkedin.svg"
                    alt="whatsapp"
                  />
                </div>
                <p>Linkedin</p>
              </LinkedinShareButton>
            </Col>
          </Row>

          <hr className="hr" />
          <p className="font-15">Share Link Via Email</p>
          <input
            type="text"
            className="form-control rounded-0 w-100"
            placeholder="email address"
            onChange={(e) => setEmail(e.target.value)}
            value={userEmail}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={sendMail}>
            Share
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Jobs;
